/* eslint-disable @typescript-eslint/naming-convention */
import { Component, effect } from '@angular/core';
import { AWCListItem } from '@ansys-internal/awc-angular/lists';
import { ArchitectureTemplate } from 'src/app/shared/enums';
import { ArchitectureService } from 'src/app/shared/services/architecture.service';
import { UnitType } from 'src/api';
import { ConceptInputComponent } from '../forms/input/concept-input.component';
import { SelectComponent, InputType } from '@ansys-internal/awc-angular/forms';

@Component({
    selector: 'app-architecture-configurations',
    templateUrl: './architecture-configurations.component.html',
    styleUrls: ['./architecture-configurations.component.scss'],
    imports: [SelectComponent, ConceptInputComponent]
})
export class ArchitectureConfigurationsComponent {
  readonly UnitType = UnitType;
  readonly InputTypes = InputType;
  protected wheelItems: AWCListItem[] = [
    {
      text: '1',
      id: '1',
    },
    {
      text: '2',
      id: '2',
    },
  ];
  protected motorItems: AWCListItem[] = [
    {
      text: '0',
      id: '0',
    },
    ...this.wheelItems,
  ];
  protected motorItemsRear: AWCListItem[] = [...this.motorItems];
  protected wheelItemsRear: AWCListItem[] = [...this.wheelItems];
  protected motorItemsFront: AWCListItem[] = [...this.motorItems];
  protected wheelItemsFront: AWCListItem[] = [...this.wheelItems];
  private wheelbase!: number;

  constructor(protected architecture: ArchitectureService) {
    effect(() => {
      this.architecture.architecture();
      this.setSelects();
    });
  }

  /**
   * Changes the architecture template.
   * @param {AWCListItem} $event event from the select component
   */
  protected changeArchTemplate($event: AWCListItem[]): void {
    this.architecture.template = $event[0].id as ArchitectureTemplate;
  }

  protected changeArchitectureWheels(id: string, rear?: boolean): void {
    this.architecture.alterWheelArchitecture(id, rear);
  }

  protected changeArchitectureMotors(id: string, rear?: boolean): void {
    const architecture = this.architecture.architecture();
    if (!architecture) return;

    if (id === '0') {
      if (rear) {
        architecture.number_of_rear_motors = 0;
        architecture.rear_motor_id = null;
        architecture.rear_inverter_id = null;
        architecture.rear_transmission_id = null;
        architecture.rear_clutch_id = null;
      } else {
        architecture.number_of_front_motors = 0;
        architecture.front_motor_id = null;
        architecture.front_inverter_id = null;
        architecture.front_transmission_id = null;
        architecture.front_clutch_id = null;
      }

      // Disconnect clutch for single driven axle not supported
      architecture.front_clutch_id = null;
      architecture.rear_clutch_id = null;

      this.architecture.setArchitecture(architecture);
    }

    this.architecture.alterMotorArchitecture(id, rear);
  }

  protected updateWheelbase($event: string | number): void {
    this.wheelbase = parseFloat($event as string);
    const architecture = this.architecture.architecture();
    if (architecture) {
      architecture.wheelbase = this.wheelbase;
      this.architecture.setArchitecture(architecture);
    }
  }

  private setSelects(): void {
    const startFrontMotorIndex =
      this.architecture.rearMotorsCount() > 0 ? 0 : 1;
    const startRearMotorIndex =
      this.architecture.frontMotorsCount() > 0 ? 0 : 1;

    this.motorItemsFront = this.motorItems.slice(
      startFrontMotorIndex,
      this.architecture.frontWheelsCount() + 1
    );
    this.wheelItemsFront = this.wheelItems.slice(
      this.architecture.frontMotorsCount()
        ? this.architecture.frontMotorsCount() - 1
        : 0
    );

    this.motorItemsRear = this.motorItems.slice(
      startRearMotorIndex,
      this.architecture.rearWheelsCount() + 1
    );
    this.wheelItemsRear = this.wheelItems.slice(
      this.architecture.rearMotorsCount()
        ? this.architecture.rearMotorsCount() - 1
        : 0
    );
  }
}
